// extracted by mini-css-extract-plugin
export default {"cuerpo":"CuerpoTorneos_cuerpo__83Baq","barra_lateral":"CuerpoTorneos_barra_lateral__s2LhQ","area_principal":"CuerpoTorneos_area_principal__2pYnQ"};